module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "userInfo"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "action": "",
      "model": _vm.form,
      "label-width": "250px",
      "width": "1000px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "NickName"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.form.name = $$v
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Giới tính"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.sex),
      callback: function($$v) {
        _vm.form.sex = $$v
      },
      expression: "form.sex"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "Nam"
    }
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "Nữ"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Ngày sinh"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "Chọn ngày"
    },
    model: {
      value: (_vm.form.date),
      callback: function($$v) {
        _vm.form.date = $$v
      },
      expression: "form.date"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Địa chỉ"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.adress),
      callback: function($$v) {
        _vm.form.adress = $$v
      },
      expression: "form.adress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Số CMND/CCCD  *"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.idno),
      callback: function($$v) {
        _vm.form.idno = $$v
      },
      expression: "form.idno"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nơi cấp CMND/CCCD"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.idnoFrom),
      callback: function($$v) {
        _vm.form.idnoFrom = $$v
      },
      expression: "form.idnoFrom"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Ngày cấp CMND/CCCD"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.idnoDate),
      callback: function($$v) {
        _vm.form.idnoDate = $$v
      },
      expression: "form.idnoDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Email *"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.form.email = $$v
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Số điện thoại"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.phone),
      callback: function($$v) {
        _vm.form.phone = $$v
      },
      expression: "form.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Ảnh đại diện"
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "list-type": "picture",
      "limit": "1",
      "on-change": _vm.handleChange,
      "on-remove": _vm.handleRemove,
      "file-list": _vm.form.fileList,
      "auto-upload": false
    }
  }, [(_vm.form.fileList.length === 0) ? _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v("Chọn ảnh")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-checkbox', {
    model: {
      value: (_vm.form.checked),
      callback: function($$v) {
        _vm.form.checked = $$v
      },
      expression: "form.checked"
    }
  }, [_vm._v("Tôi đã đọc kỹ và hoàn toàn đồng ý với "), _c('a', {
    attrs: {
      "href": "/Agreement.pdf",
      "target": "_blank"
    }
  }, [_vm._v("Thỏa Thuận Cung Cấp và Sử Dụng Dịch Vụ của Báo Hay 24h")]), _vm._v(". ")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57ed6474","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserInfoInput.vue
// module id = 926
// module chunks = 1